import * as DatasetHelper from '../dataset-helper';

/**
 * Helper class for calculating historical weighting of sites.
 */
export default class HistoricalWeightingCalculator {

  calculate(calculationDefn, dataset, referenceSitesHash, selectedSiteIds) {
    const allSitesHash = referenceSitesHash;

    // Define the result object that will be returned by the method.
    let historicalWeighting = 0.0;

    // Only attempt to calculate if a dataset is provided.
    if (dataset) {

      // Identify the field.
      const fieldDefn = calculationDefn.field;
      const field = DatasetHelper.findField(dataset, fieldDefn.fieldId);
      const fieldName = field.fieldName;

      let selectedSitesAccumulator = 0.0;
      let allSitesAccumulator = 0.0;

      // Loop through every site.
      Object.keys(allSitesHash).forEach((siteId) => {
        const site = allSitesHash[siteId];
        const isSiteSelected = selectedSiteIds.includes(siteId);
        const fieldValue = site.data[fieldName];

        // Count/Accumulate as required.
        if (isSiteSelected) {
          selectedSitesAccumulator = selectedSitesAccumulator + Math.pow(fieldValue, 2);
        }
        allSitesAccumulator = allSitesAccumulator + Math.pow(fieldValue, 2);
      });

      historicalWeighting = 1 - (selectedSitesAccumulator / allSitesAccumulator);

    }

    return historicalWeighting;

  }

}



// WEBPACK FOOTER //
// ./src/app/utils/calculators/historical-weighting-calculator.js